export const formatIdForDeserialization = (entity: any): any => {
  if (!entity) {
    return entity;
  }
  if (Array.isArray(entity)) {
    return entity.map(item => formatIdForDeserialization(item));
  }
  if (typeof entity !== 'object') {
    return entity;
  }

  const keys = Object.keys(entity);
  const res = { ...entity };
  keys.forEach(key => {
    if (typeof key !== 'string') {
      return;
    }

    if (typeof entity[key] !== 'string') {
      res[key] = formatIdForDeserialization(entity[key]);
      return;
    }

    if (!key.endsWith('Id')) {
      return;
    }

    const mainKey = key.substr(0, key.length - 2);
    if (entity[mainKey]) {
      return;
    }
    res[mainKey] = entity[key];
  });
  return res;
};
